import React from 'react';
import * as Styles from './FieldItem.styles';

const FieldItem = ({
  name, active, textAlign, onClick,
}) => {
  const handleOnClick = () => {
    onClick && onClick(name);
  };

  return (
    <Styles.FieldItem onClick={handleOnClick} active={active} textAlign={textAlign}>
      <>{name}</>
    </Styles.FieldItem>
  );
};

export default FieldItem;
